import { MANUAL_ACTIVATE_SUBSCRIPTION_BY_EMAIL } from "../api-services/ApiEndpoints";

export const manualActivateSubscription = async (email, packageId, reason) => {
    const url = `${process.env.REACT_APP_API_URL}${MANUAL_ACTIVATE_SUBSCRIPTION_BY_EMAIL.replace('{email}', email)}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            packageId: packageId,
            reason: reason
        })
    });
    
    if (!response.ok) {
        throw new Error(`Failed to activate subscription: ${response.status}`);
    }
    
    return await response.json();
};